
import React, { useState, useEffect } from 'react'
import { Button, Checkbox } from 'antd'
import axios from '../../../utils/request';
import Message from '@beisen-phoenix/message'
import { getUrlParams } from '../../../utils'
import pengxinweiLogo from '../../../imgs/pengxinwei_logo.png'
import './index.scss'

const CommitmentLetter = () => {
    const [submitLoading, setSubmitLoading] = useState(false)//submitLoading
    const [isAgreed, setIsAgreed] = useState(false)//已经阅读并同意
    const [email, setEmail] = useState()//email,修改状态接口后端需要
    const [mobile, setMobile] = useState()//email,修改状态接口后端需要
    const {
        tenantId,
    } = getUrlParams()

    const { returnUrl } = getUrlParams('hash')
    const returnUrlParams = new URLSearchParams(returnUrl)
    const userId = returnUrlParams.get('userId')

    useEffect(() => {
        //或隐私协议状态，如果“隐私协议状态”为”是“，则直接跳转到标品页面;如果“隐私协议状态”为”否“，就需要先”同意签署“
        axios.get('/api/PengXinWei/GetPrivacyStatusByPortalUserId', {
            params: {
                tenantId,
                portalUserId: userId,
            }
        })
            .then(res => {

                const {
                    code,
                    data,
                    message,
                } = res.data

                if (code === '200') {
                    if (data.PrivacyStatus === '1') {//隐私协议状态"0":否,"1":是
                        window.location = returnUrl
                    } else {
                        setEmail(data.Email)
                        setMobile(data.Mobile)
                    }
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            }).finally(() => setSubmitLoading(false))
    }, [])

    //修改应聘者【隐私协议状态】为"是"
    const save = () => {
        if (!isAgreed) {
            return
        }

        setSubmitLoading(true)
        axios.get('/api/PengXinWei/RecordSignInfomation', {
            params: {
                tenantId,
                portalUserId: userId,
                email,
                mobile,
            }
        })
            .then(res => {
                const {
                    code,
                    message,
                } = res.data
                if (code === '200') {
                    window.location = returnUrl
                } else {
                    Message.error({ message: message || '服务器异常' })
                }
            }, error => {
                Message.error({ message: error.message })
            }).finally(() => setSubmitLoading(false))
    }

    return (
        <div className='pengxinwei-commitment-letter'>
            <div className='commitment-letter-header'>
                <h4>
                    隐私协议签署
                </h4>
                <img className='pengxinwei-logo' src={pengxinweiLogo} alt="鹏芯微logo" />
            </div>
            <div className='commitment-letter-body'>
                <h5 className='term-title'>
                    一、知识产权和商业秘密保护承诺函
                </h5>
                <div className='term-content-one'>
                    深圳市鹏芯微集成电路制造有限公司（以下简称“鹏芯微”）尊重他人知识产权、商业秘密及其他合法权益，在保护自身知识产权和商业秘密的同时，反对、不需要、不接受交流人或候选人在交流、入职前或入职后向鹏芯微披露其原工作单位及任何第三方的知识产权和商业秘密。对此，本人已知晓，并承诺： 1、遵守与原工作单位/项目或任何其他第三方已签署的保密协议和相关要求，不违反任何保密义务，亦未侵犯原工作单位/项目或任何其他第三方的知识产权、商业秘密及其他合法权益。 2、交流过程中，若被问及的内容触及到本人与原工作单位/项目或任何其他第三方的保密义务内容，本人将拒绝回答此问题，并示意该问题可能涉密。 3、不将原工作单位/项目或任何其他第三方的任何商业秘密或任何保密信息带到鹏芯微，且不在鹏芯微工作中使用或披露。 4、若本人违反与原工作单位/项目或第三方的保密义务，与鹏芯微无关，本人将独自承担违约责任及相关法律责任。鹏芯微将有权取消本人的录用资格，失效已签发的offer；若本人已入职，鹏芯微亦有权解除与本人的劳动合同。如果因本人违约行为给鹏芯微造成损失的，本人愿意承担赔偿责任。
                </div>
                <h5 className='term-title'>
                    二、职位申请承诺书
                </h5>
                1、我保证遵守与原工作单位/项目或任何其他第三方已签署的保密协议和相关要求，不违反任何保密义务，亦不侵犯原工作单位/项目或任何其他第三方的知识产权与保密信息。<br />
                2、我保证到贵公司报到前，已与原工作单位解除劳动合同关系且不存在任何入职贵公司的法律或协议限制或障碍。<br />
                3、我保证所填写表格的每一项内容及所提供的个人信息（包括应聘登记表、简历、证书，及其它在应聘过程中提供的个人材料）的真实性，并愿意接受公司或其委托的合法机构对上述所有信息调查确认。如有作假行为，愿接受公司的取消录用资格或解除劳动合同的处理。<br />
                4、我愿意接受公司的入职培训和试用管理，若在试用期内达不到公司要求，公司可按相关规定终止劳动合同关系，无需任何补偿。<br />
                5、我已知悉公司所采用的身体健康状况检查标准，若本人身体状况未通过健康检查合格标准，本人同意贵公司取消录用资格或解除劳动合同。
            </div>
            <div className='commitment-letter-footer'>
                <Checkbox
                    onChange={e => setIsAgreed(e.target.checked)}>
                    我已经阅读并同意《知识产权和商业秘密保护承诺函》和《职位申请承诺书》
                </Checkbox>
                <div className={!isAgreed ? 'hide' : null}>
                    <Button className='save' type="primary" size="large" loading={submitLoading} onClick={save}>
                        同意签署
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CommitmentLetter